export enum RecorderState {
    INITIALIZING,
    INITIALIZED,
    RECORDING,
    PAUSED,
    STOPPING,
    STOPPED
}